import { t, useI18n } from "@bookingcom/lingojs-react";
import { useAirlinesCampaignPerformanceQuery } from "../../../hooks/useAirlinesCampaignPerformanceQuery";
import { useCampaignPerformanceQuery } from "../../../hooks/useCampaignPerformanceQuery";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { useAuth } from "../../../hooks/useAuth";
import { ChartNoData } from "../ChartNoData";
import { SearchCoverageChart } from "./SearchCoverageChart";

export type SearchCoverageChartLoaderProps = {
  from: Date;
  to: Date;
};

export const SearchCoverageChartLoader = ({ from, to }: SearchCoverageChartLoaderProps) => {
  const i18n = useI18n();
  const { isAirlineUser } = useAuth();
  const useQuery = isAirlineUser ? useCampaignPerformanceQuery : useAirlinesCampaignPerformanceQuery;
  const { selectedAirline } = useSelectedAirline({ useSuspense: true });
  const { data: metrics } = useQuery({
    from,
    to,
    metrics: ["SEARCH_COVERAGE_PERCENTAGE"],
    airlineCode: selectedAirline?.code,
  });

  const searchCoverageMetric = metrics.find((metric) => metric.metadata.metricName === "SEARCH_COVERAGE_PERCENTAGE");
  if (!searchCoverageMetric) {
    return <ChartNoData titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_name"))} />;
  }

  return <SearchCoverageChart metric={searchCoverageMetric} />;
};
